import { Download, ExternalLink } from "lucide-react";
import { Navigate, useParams } from "react-router-dom";
import { AssetPreview } from "../components/AssetPreview";
import { CopyButton } from "../components/CopyButton";
import { LastUpdated } from "../components/LastUpdated";
import { PageHeader } from "../components/PageHeader";
import { StatusBadge } from "../components/StatusBadge";
import { WarningCallout } from "../components/WarningCallout";
import { brandAssets } from "../data/brandAssets";
import { requestTelegramFileDownload } from "../lib/telegram";

export function AssetDetailsPage() {
  const { assetId } = useParams();
  const asset = brandAssets.find((item) => item.id === assetId);
  if (!asset) return <Navigate to="/assets" replace />;

  const available = !asset.placeholder && !asset.url.startsWith("#");
  const absoluteUrl = available ? new URL(asset.url, window.location.origin).href : "";
  const downloadsDirectly = asset.category === "logo";
  const downloadName = downloadsDirectly ? asset.url.split("/").pop() : undefined;

  return (
    <div className="page page--narrow">
      <PageHeader eyebrow="Материал" title={asset.title} description={asset.description} back />
      <article className="asset-detail">
        <AssetPreview asset={asset} large />
        <div className="asset-detail__content">
          <div className="detail-card__badges"><StatusBadge status={asset.status} /><span className="file-type">{asset.fileType.toUpperCase()}</span></div>
          <dl className="details-list">
            <div><dt>Версия</dt><dd>{asset.version ?? "Не указана"}</dd></div>
            <div><dt>Язык</dt><dd>{asset.language?.toUpperCase() ?? "Не указан"}</dd></div>
            <div><dt>Размер</dt><dd>{asset.fileSize ?? "Не указан"}</dd></div>
          </dl>
          <div className="usage-rules"><strong>Правила использования</strong><p>{asset.usage ?? "Правила не добавлены."}</p></div>
          {asset.status === "needs-review" && <WarningCallout>Перед использованием необходимо уточнить актуальность материала.</WarningCallout>}
          {!available && <WarningCallout title="Файл недоступен">Ссылка на файл ещё не добавлена.</WarningCallout>}
          <LastUpdated date={asset.updatedAt} />
          <div className="tag-list">{asset.tags.map((tag) => <span key={tag}>{tag}</span>)}</div>
          {available && (
            <div className="card-actions card-actions--stack-mobile">
              <a
                className="button button--primary"
                href={asset.url}
                target={downloadsDirectly ? undefined : "_blank"}
                rel={downloadsDirectly ? undefined : "noreferrer"}
                download={downloadName}
                onClick={downloadsDirectly
                  ? (event) => {
                      if (requestTelegramFileDownload(asset.url, downloadName ?? "social-logo.svg")) {
                        event.preventDefault();
                      }
                    }
                  : undefined}
              >
                {downloadsDirectly ? "Скачать файл" : "Открыть файл"}
                {downloadsDirectly
                  ? <Download size={17} aria-hidden="true" />
                  : <ExternalLink size={17} aria-hidden="true" />}
              </a>
              <CopyButton text={absoluteUrl} label="Скопировать ссылку" />
            </div>
          )}
        </div>
      </article>
    </div>
  );
}
